<template>
  <div class="join-page">
    <section class="banner">
      <h1>加入九恒</h1>
      <p>光明的产业 共同的事业</p>
    </section>
    <div class="ctn" :class="delayed ? 'scrolled' : ''">
      <h2>企业文化</h2>
      <p>
        九恒的企业文化是“圆”的文化，将“事求卓越、和谐共赢”的经营理念与“圆全、灵活、完美、融合”的精神内涵有机结合，对产品与服务坚持高标准、严要求、追求圆满的工作境界，对员工、客户、投资人、合作伙伴圆融团结、彼此成就，达到共生共赢的和谐状态。
      </p>
      <img src="@/assets/j2.jpg"/>
    </div>
    <div class="ctn" :class="scrolledTop >= 500 ? 'scrolled' : ''">
      <img src="@/assets/j17.png"/>
      <img src="@/assets/j18.png"/>
      <img src="@/assets/j19.png"/>
      <img src="@/assets/j20.png"/>
      <img src="@/assets/j21.png"/>
      <img src="@/assets/j22.png"/>
      <img src="@/assets/j23.png"/>
      <img src="@/assets/j24.png"/>
      <img src="@/assets/j25.png"/>
      <img src="@/assets/j15.png"/>
    </div>
    <div class="tab-ctn">
      <div class="ctn">
        <h2>加入九恒，您将获得</h2>
        <ul class="tab">
          <li :class="{c: curImg === 0}" @click="curImg = 0">平台发展</li>
          <li :class="{c: curImg === 1}" @click="curImg = 1">福利保障</li>
          <li :class="{c: curImg === 2}" @click="curImg = 2">晋升通道</li>
          <li :class="{c: curImg === 3}" @click="curImg = 3">成长激励</li>
        </ul>
        <div class="tab-content">
          <img :class="curImg === 0 ? 'visb' : ''" src="@/assets/j4.jpg"/>
          <img :class="curImg === 1 ? 'visb' : ''" src="@/assets/j5.jpg"/>
          <img :class="curImg === 2 ? 'visb' : ''" src="@/assets/j6.jpg"/>
          <img :class="curImg === 3 ? 'visb' : ''" src="@/assets/j7.jpg"/>
          <img :class="curImg === 0 ? 'visb' : ''" class="corner" src="@/assets/j11.jpg"/>
          <img :class="curImg === 1 ? 'visb' : ''" class="corner" src="@/assets/j12.jpg"/>
          <img :class="curImg === 2 ? 'visb' : ''" class="corner" src="@/assets/j13.jpg"/>
          <img :class="curImg === 3 ? 'visb' : ''" class="corner" src="@/assets/j14.jpg"/>
        </div>
      </div>
    </div>
    <div class="entry">
      <h3></h3>
      <div class="link">
        <a href="#/Job">社会招聘</a>
        <a href="#/Job/6">校园招聘</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  data() {
    return {
      curImg: 0,
      scrolledTop: 0,
      delayed: false
    }
  },
  created() {
    document.body.addEventListener('scroll', this.scrolling)
    setTimeout(() => {
      this.delayed = true
    }, 300)
  },
  methods: {
    scrolling() {
      const s = document.body.scrollTop
      this.scrolledTop = s > this.scrolledTop ? s : this.scrolledTop
    }
  },
  destroyed() {
    document.body.removeEventListener('scroll', this.scrolling)
  }
}
</script>
